var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCardTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44 21.25c-3.98 0-5.2-1.2-5.2-5.14V7.89c0-3.15.67-4.9 4.24-5.11.3-.01.62-.02.96-.02h11.11c3.98 0 5.2 1.2 5.2 5.14v4.41c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7.9c0-3.09-.55-3.64-3.7-3.64H6.44c-.32 0-.61.01-.89.02-2.17.13-2.81.62-2.81 3.62v8.22c0 3.09.55 3.64 3.7 3.64h5.11c.41 0 .75.34.75.75s-.33.74-.75.74H6.44z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75H6z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.94 20.44c-.45-.72-.69-1.57-.69-2.44 0-2.62 2.13-4.75 4.75-4.75s4.75 2.13 4.75 4.75c0 .87-.24 1.72-.69 2.45-.84 1.42-2.4 2.3-4.06 2.3-1.66 0-3.22-.88-4.06-2.31zm.81-2.44c0 .59.16 1.17.47 1.67.58.98 1.65 1.58 2.78 1.58A3.256 3.256 0 0 0 21.25 18c0-1.79-1.46-3.25-3.25-3.25s-3.25 1.46-3.25 3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.899 19.52-.99-.99a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.48.48 1.6-1.48c.3-.28.78-.26 1.06.04s.26.78-.04 1.06l-2.13 1.97c-.15.13-.33.2-.51.2-.19 0-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCardTick);
export default __webpack_public_path__ + "static/media/vuesax-outline-card-tick.80755aa49cdf1ff030cf3644a515d1f7.svg";
export { ForwardRef as ReactComponent };